






















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import formatAmount from '@/filters/formatAmount';
import { GQL_paychecksByYear_paychecksByYear } from '@/queries/__generated__/paychecksByYear';

@Component
export default class PaychecksSummary extends Vue {
  @Prop({ required: true }) readonly paychecks!: GQL_paychecksByYear_paychecksByYear[]
  @Prop({ required: true }) readonly descriptions!: string[]

  private formatAmount = formatAmount
}
